// @flow

import Collection from '../../Collection';

export default class SuggestionsBuilder {
  suggestions: Array<any>;
  dataLayerSuggestions: Collection<Object>;

  /**
   * Create a new SuggestionsBuilder
   */
  constructor(suggestions: Array<any>, dataLayerSuggestions: Collection<Object>) {
    this.suggestions = suggestions;
    this.dataLayerSuggestions = dataLayerSuggestions;
  }

  /**
   * Builds specific search suggestions.
   */
  build(): HTMLElement {
    const wrapper: HTMLElement = document.createElement('div');
    wrapper.className = 'suggestions__group';
    wrapper.innerHTML = this.template();
    return wrapper;
  }

  /**
   * Build the suggestions.
   */
  buildSuggestions(): string {
    let suggestions: string = '';
    this.suggestions.forEach((suggestion: any) => {
      suggestions += this.suggestion(suggestion);
    });
    return suggestions;
  }

  /**
   * Return the whole template as a string.
   */
  template(): string {
    throw new Error('Abstract method');
  }

  /**
   * Return one suggestion as a template string.
   */
  suggestion(suggestion: any): string {
    throw new Error('Abstract method');
  }

  /**
   * Check if the data provided is valid to create new suggestions.
   */
  static hasValidData(data: any): boolean {
    throw new Error('Abstract method');
  }
}
